import React from "react";
import Hint from "../../utils/Hint/Hint";

// Import menu subsections
import { MenuComponent } from "./_menuComponent/MenuComponent";

const MenusSection = ({ allMenus, handleUpdateMenu, dishes }) => {
  return (
    <section className="section menusSection">
      <Hint
        hintHeading="Menus interface"
        hintText={`
        <div>
        <div>
        In the employee sub-application, the menus interface functionality is restricted to two actions: change the number of items in stock in currently published menus, and download PDF of to-print menus.
        </div>
        <div>
        This allows the employee responsible for handling orders to efficiently change the number of items in stock.
        </div>
        <div>
        Depending on the requirements of the business, the functionality might be extended or narrowed down further.
        </div>
          </div>
        `}
        openOnMount={false}
        top="5em"
      />
      <h2 className="sectionHeading">MENUS</h2>
      <h3 style={{ textAlign: "center" }} className="subSection__heading">
        ACTIVE & PRINTED MENUS
      </h3>
      {allMenus &&
        allMenus
          .filter((m) => m.active || m.purposeType === "print")
          .map((menu) => (
            <MenuComponent
              key={menu._id}
              handleUpdateMenu={handleUpdateMenu}
              menu={menu}
              dishes={dishes}
            />
          ))}
    </section>
  );
};

export default MenusSection;
